import React, { useContext, useState } from "react";
import styles from "./faqs.css";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "../../contexts/LanguageContext";
// import { LanguageContext } from "../../context/LanguageContext";


export const Faqs = () => {
  const { t } = useTranslation("faqs");
  // const { language } = useContext(LanguageContext);
const { language } = useContext(LanguageContext);


  const questions = t("questions", { returnObjects: true });

  const [activeIndex, setActiveIndex] = useState(null);

  const handleTabChange = (e) => {
    setActiveIndex(e.index);
  };

  const createDynamicFaqs = () => {
    return questions.map((tab, i) => {
      return (
        <AccordionTab
          key={tab.q}
          header={
            <div className={` ${activeIndex === i ? 'active_according' : ""}`}>
              <span className={'gradient_text'}>
                {/* <img  src={activeIndex === i ? './assets/images/down.png' : './assets/images/side.png'} style={{width:'16px', marginRight:'10px'}} alt="icon" /> */}
                {tab.q}
                {
                  activeIndex===i ?
                  (
                    <img  src="/assets/images/white/plus.svg" style={{width:'16px',  marginLeft: language === 'ar' ? '10px' : '0', marginRight: language === 'ar' ? '0' : '10px',}} alt="icon" />
                  ):(
                    <img  src="/assets/images/white/plus.svg" style={{width:'16px', marginLeft: language === 'ar' ? '10px' : '0', marginRight: language === 'ar' ? '0' : '10px', transform: language==='ar' ? 'rotate(180deg)' : 'none'}} alt="icon" />
                  )
                }
              </span>
            </div>
          }
          disabled={tab.disabled}
          className={`collapse_header`}
        >
          <div className={'accordion_body'}>
            <p className="m-0">{tab.a} </p>
            
          </div>
        </AccordionTab>
      );
    });
  };
  
  // ========================================================================================================
  return (
    <div className={`${'page_content'} container`}>
      <div className="row align-items-center">
        <div className="col-12 col-md-8 test_faqs">
          <Accordion activeIndex={activeIndex} onTabChange={handleTabChange} className="faqs">
            {createDynamicFaqs()}
          </Accordion>
        </div>
      </div>
    </div>
  );
};  
